import React from 'react';
import styles from './StatusPill.styles';
import { AllocationStatus } from 'shared/models/enums/AllocationStatus';

const StatusPill = ({ status, tableItem }) => {
  const Status = ({ status }) => {
    switch (status) {
      case AllocationStatus.Active:
        return <div className={`status-pill active`}>Active</div>;
      case AllocationStatus.Waitlisted:
        return <div className={`status-pill waitlisted`}>Waitlisted</div>;
      case AllocationStatus.Pending:
        return <div className={`status-pill pending`}>Pending</div>;
      case AllocationStatus.Terminated:
        return <div className={`status-pill terminated`}>Terminated</div>;
      case AllocationStatus.Cancelling:
        return <div className={`status-pill cancelling`}>Cancelling</div>;
      default:
        return <div className={`status-pill none`}>No Allocations</div>;
    }
  };

  return (
    <div css={styles} style={tableItem ? { width: '100%' } : { alignSelf: 'self-end' }}>
      <Status status={status} />
    </div>
  );
};

export default StatusPill;
